export interface IPmtCalculateParams {
    amount: number;
    tenure: number;
    interestRate: number;
}

export const calculatePmt = (request: IPmtCalculateParams): number => {
    const { amount, tenure, interestRate } = request;

    if (interestRate == 0) {
        return amount / tenure;
    }

    const monthlyRate = interestRate / 100;
    const interestFactor = Math.pow((1 + monthlyRate), tenure);

    return (amount * (monthlyRate * interestFactor)) / (interestFactor - 1);
}
